exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-puzzles-js": () => import("./../../../src/pages/puzzles.js" /* webpackChunkName: "component---src-pages-puzzles-js" */),
  "component---src-pages-test-js": () => import("./../../../src/pages/test.js" /* webpackChunkName: "component---src-pages-test-js" */),
  "component---src-templates-crosswordpuzzle-js": () => import("./../../../src/templates/crosswordpuzzle.js" /* webpackChunkName: "component---src-templates-crosswordpuzzle-js" */)
}

